module.exports = __webpack_public_path__ + "static/media/YF55_0.9e7038a7.jpg";